import { message } from 'antd'
import styled from 'styled-components'

/**
 * Copy a raw ticket id to the clipboard and toast the outcome. Wraps
 * `navigator.clipboard.writeText` so the promise rejection (insecure
 * origin, permission denied, etc.) surfaces as a user-facing error
 * instead of an unhandled rejection.
 */
export const copyTicketId = (id: string): void => {
  navigator.clipboard
    .writeText(id)
    .then(() => {
      message.success({ content: `Copied: ${id}`, duration: 2 })
    })
    .catch(() => {
      message.error({
        content: `Could not copy id`,
        duration: 2,
      })
    })
}

/**
 * Button used to render a ticket title + copy-on-click icon. Shared by
 * the stats drawer and the ticket-metrics breakdown so the hover affordance
 * stays visually consistent.
 */
export const TicketTitleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: inherit;
  text-align: left;

  .anticon {
    opacity: 0;
    font-size: 0.75rem;
    transition: opacity 0.15s;
  }

  &:hover {
    text-decoration: underline;
    .anticon {
      opacity: 1;
    }
  }
`
